import React, { useContext } from "react";
import { type TableColumn } from "./common";
import { MySelectionContext } from "./MySelection";
import Table from "./Table";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

export interface MySelectionTableProps<T> {
  items: T[]
  isLoading: boolean
  getKey: (item: T) => string
  columns: Array<TableColumn<T>>
  title?: string
  hideHeader?: boolean
  pagination?: React.ReactNode
  exportButton?: React.ReactNode
  onEdit?: (item: T) => void
  canEdit?: (item: T) => boolean
  canDelete?: (item: T) => boolean
  onDelete?: (item: T) => void
  layoutButtons?: React.ReactNode
}

const MySelectionTable = <T extends server.dto.IHasObjectPermissions>(props: MySelectionTableProps<T>) => {
  const {
    items,
    isLoading,
    getKey,
    columns,
    title,
    hideHeader,
    pagination,
    exportButton,
    onEdit,
    layoutButtons
  } = props;
  const mySelection = useContext(MySelectionContext);

  const canEditItem = (item: T) => {
    return item.permissions.canModify && onEdit != null;
  };

  const parsedColumns = mySelection.enabled
    ? [{
      key: "mySelection",
      header: "",
      width: 38,
      render: (item: T) => (
        <Checkbox
          checked={mySelection.isSelected(item)}
          onChange={() => { mySelection.toggleItem(item); }}
        />
      )
    },
    ...columns
    ]
    : columns;

  return <Table
    items={items}
    isLoading={isLoading}
    getKey={getKey}
    columns={parsedColumns}
    pagination={pagination}
    exportButton={exportButton}
    title={title}
    hideHeader={hideHeader}
    onEdit={onEdit}
    canEdit={canEditItem}
    onDelete={props.onDelete}
    canDelete={props.canDelete}
    isSelected={item => mySelection.isSelected(item)}
    selectionEnabled={mySelection.enabled}
    selectionCount={mySelection.selectionCount}
    selectedOnThisPage={mySelection.selectedOnThisPage}
    showingOnlyMySelection={mySelection.showOnlyMySelection}
    toggleAll={mySelection.toggleAll}
    layoutButtons={layoutButtons}
  />;
};

export default MySelectionTable;